import type { ModuleMigrationDef } from "@kubdee/sdk";

/**
 * Expand `facebook-page` from MVP posting to full Page-management readiness:
 *
 * - Keep the Graph v25.0 OAuth endpoints.
 * - Request Page post, engagement, metadata/webhook, comment moderation, and
 *   Business Portfolio traversal permissions.
 * - Add `FACEBOOK_PAGE_CONFIG_ID` support for Facebook Login for Business.
 * - Record Page feed webhook verification config for the ingress dashboard.
 *
 * Existing tenants already ran migration 011, so this migration updates the
 * persisted connector type row instead of relying on the old INSERT OR IGNORE
 * seed to run again.
 */
export const migration: ModuleMigrationDef = {
  key: "012_facebook_page_full_scope",
  version: "0.12.0",
  sql: `
UPDATE \`connectors_types\`
   SET \`oauth_config\` = json_set(
         COALESCE(\`oauth_config\`, '{}'),
         '$.tokenUrl',
         'https://graph.facebook.com/v25.0/oauth/access_token',
         '$.clientIdEnv',
         'FACEBOOK_PAGE_CLIENT_ID',
         '$.clientIdEnvFallbacks',
         json_array('FACEBOOK_MESSENGER_CLIENT_ID'),
         '$.clientSecretEnv',
         'FACEBOOK_PAGE_CLIENT_SECRET',
         '$.clientSecretEnvFallbacks',
         json_array('FACEBOOK_MESSENGER_CLIENT_SECRET', 'FB_APP_SECRET'),
         '$.authorizeUrl',
         'https://www.facebook.com/v25.0/dialog/oauth',
         '$.scopes',
         json_array(
           'pages_show_list',
           'pages_manage_posts',
           'pages_read_engagement',
           'pages_manage_metadata',
           'pages_read_user_content',
           'pages_manage_engagement',
           'business_management'
         ),
         '$.configIdEnv',
         'FACEBOOK_PAGE_CONFIG_ID'
       ),
       \`webhook_config\` = json_set(
         COALESCE(\`webhook_config\`, '{}'),
         '$.signatureHeader',
         'x-hub-signature-256',
         '$.algorithm',
         'HMAC-SHA256',
         '$.secretEnv',
         'FB_APP_SECRET',
         '$.events',
         json_array('feed')
       ),
       \`updated_at\` = '2026-05-24T00:00:00Z'
 WHERE \`id\` = 'facebook-page'
   AND (
     json_extract(\`oauth_config\`, '$.configIdEnv') IS NULL
     OR json_extract(\`oauth_config\`, '$.clientIdEnvFallbacks[0]') != 'FACEBOOK_MESSENGER_CLIENT_ID'
     OR json_extract(\`oauth_config\`, '$.clientSecretEnvFallbacks[0]') != 'FACEBOOK_MESSENGER_CLIENT_SECRET'
     OR json_extract(\`oauth_config\`, '$.clientSecretEnvFallbacks[1]') != 'FB_APP_SECRET'
     OR json_extract(\`oauth_config\`, '$.scopes[3]') != 'pages_manage_metadata'
     OR json_extract(\`oauth_config\`, '$.scopes[4]') != 'pages_read_user_content'
     OR json_extract(\`oauth_config\`, '$.scopes[5]') != 'pages_manage_engagement'
     OR json_extract(\`oauth_config\`, '$.scopes[6]') != 'business_management'
     OR \`webhook_config\` IS NULL
     OR json_extract(\`webhook_config\`, '$.events[0]') != 'feed'
   );
  `.trim(),
};
